<template lang="pug">
    .section__heading
      .title.section__title(
        :class="{ 'section__title--contrast' : isContrast }",
        v-fade
      )
        .section__number 0{{number}}/
        h2.section__title-text {{text}}
      .text-body.section__description(v-fade) {{ description }}
</template>

<script>
export default {
  name: "SectionTitle",
  props: {
    isContrast: {
      type: Boolean,
      required: false
    },
    text: {
      type: String,
      required: true
    },
    number: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    }
  }
};
</script>

<style lang="scss">
@import "../styles/main.scss";

.section {
  padding: 50px 0;
  box-sizing: border-box;

  &:first-of-type {
    padding: 0;
  }

  @include from("xxxl") {
    padding-bottom: 150px;
  }

  &__heading {
    margin: 0 auto;
    text-align: center;
    padding: 0 35px;

    @include from("sm") {
    }
    @include from("lg") {
      width: 55%;
    }
  }
  &__title {
    color: $color-text--contrast;

    &--contrast {
      .section__title-text {
        color: $color-text;

        @include from("lg") {
          background: $color-gradient;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }
  }
  &__title-text {
    display: inline;
    white-space: pre-wrap;
  }
  &__number {
    font-size: 25px;
    font-family: $font-fmbolyarpro;
    line-height: 1.3;
    color: $color-text;
    transform: translate(-1.5em, -1.2em);
    display: inline-block;
    position: absolute;

    @include from("lg") {
      font-size: 37px;
    }
  }
  &__description {
    margin: 18px auto 0;
    width: 80%;

    @include from("md") {
      width: 90%;
    }
    @include from("xl") {
      width: 650px;
    }
    @include from("xxxl") {
      width: 900px;
    }
  }
}

_:-ms-fullscreen,
:root {
  .section__title-text {
    background: rgba(255, 255, 255, 0);
  }
  .section__number {
    position: static;
  }
}

</style>
